import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  common_loading: false,
  user_details: null,
  show_toast_modal: false,
  toast_title: null,
  toast_description: null,
  is_error: false,
  error_status: null,
  otp_timer: 60,
  dashboard_key: 0,
  saved_form_steps: [],
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCommonLoading: (state, action) => {
      state.common_loading = action.payload;
    },
    setUserDetails: (state, action) => {
      state.user_details_loading = action.payload;
    },
    setToastData: (state, action) => {
      state.show_toast_modal = action.payload?.show_toast_modal;
      state.toast_title = action.payload?.toast_title;
      state.toast_description = action.payload?.toast_description;
      state.is_error = action.payload?.is_error;
      state.error_status = action.payload?.error_status;
    },
    setOtpTimer: (state, action) => {
      state.otp_timer = action.payload;
    },
    setFormStepSaved: (state, action) => {
      if (!state.saved_form_steps.includes(action.payload)) state.saved_form_steps.push(action.payload);
    },
    setDashboardKey: (state) => {
      state.dashboard_key = state.dashboard_key + 1;
    },
  },
});

export const { setCommonLoading, setUserDetails, setToastData, setOtpTimer, setDashboardKey, setFormStepSaved } = commonSlice.actions;

export default commonSlice.reducer;
